import { ContentBlock } from "@/types";
import { createSecurityServiceContent } from "@/content/services/service-content-helpers";

export const content: ContentBlock[] = [
  ...createSecurityServiceContent({
    serviceName: "mobile patrols",
    summary:
      "Mobile patrols provide a visible security presence without a guard stationed on site for the full period. Ozy Wide Group can plan patrol timing, checkpoints, lockup or unlock duties and reporting so the property is checked consistently.",
    suitedTo: [
      "industrial properties",
      "commercial yards",
      "vacant buildings",
      "retail strips",
      "construction sites",
      "multi-site businesses",
    ],
    includes: [
      "scheduled patrols",
      "randomised site checks",
      "lockup and unlock support",
      "alarm response coordination",
      "patrol reporting",
    ],
    notes: [
      "patrol windows",
      "access keys or codes",
      "priority areas",
      "lighting",
      "after-hours contacts",
      "incident photos or notes",
    ],
    process: [
      "Confirm the patrol objective, property access method and priority areas to check.",
      "Set patrol windows or randomised attendance to support deterrence.",
      "Report relevant observations and escalate urgent issues through the agreed contact path.",
    ],
    faq: [
      "Patrols can be scheduled, randomised or tied to specific lockup and unlock routines.",
      "Reliable site access details are essential so patrols can complete the agreed checks.",
      "Photos, notes and escalation rules should be agreed before patrols begin.",
    ],
  }),
];
